// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"473":"c7de95a28b5e2b310d56","884":"a58c321050b0748aa579"}[chunkId] + ".chunk.js";
};